/* eslint no-bitwise: ["error", { "allow": [">>", "&"] }] */
import translate from './translate';

const supportsGenerator = () => {
  const div = document.createElement('div');
  const vendors = ['Khtml', 'Ms', 'O', 'Moz', 'Webkit'];
  let len = vendors.length;

  return (prop) => {
    if (prop in div.style) return true;

    const modifiedProp = prop.replace(/^[a-z]/, val => val.toUpperCase());

    while (len) {
      len -= 1;
      if (vendors[len] + modifiedProp in div.style) {
        return true;
      }
    }

    return false;
  };
};

function checkIfArray(item) {
  return Object.prototype.toString.call(item) === '[object Array]';
}

export function hexToRgbA(hex, alpha) {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = `0x${c.join('')}`;
    return `rgba(${[(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',')},${alpha})`;
  }
  throw new Error('Bad Hex');
}

export function supports(prop) {
  return supportsGenerator()(prop);
}

export function ready(fn) {
  if (document.attachEvent ? document.readyState === 'complete' : document.readyState !== 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn, false);
  }
}

export function fetcher(options) {
  const {
    url,
    body,
    type,
    headers,
  } = options;

  if (!type) {
    throw new Error('No type provided');
  }

  return new Promise((resolve, reject) => {
    const request = new window.XMLHttpRequest();

    request.open(type, url, true);

    if (headers) {
      for (let i = 0; i < headers.length; i += 1) {
        if (headers[i]) {
          const headerType = Object.keys(headers[i])[0];
          const headerTypeValue = headers[i][headerType];
          request.setRequestHeader(headerType, headerTypeValue);
        }
      }
    }

    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        if (request.responseText.length > 0) {
          const response = JSON.parse(request.responseText);
          resolve(response.data);
        } else {
          resolve(true);
        }
      } else {
        reject(new Error(`Error: ${request.status} - ${request.statusText}`));
      }
    };

    request.onerror = () => {
      reject(new Error(`Error: ${translate('error_no_internet_connection')}`));
    };

    request.send(body);
  });
}

export function getParentByClassName(_elem, className) {
  let elem = _elem;

  while (elem && elem.classList && !elem.classList.contains(className)) {
    elem = elem.parentNode;
  }
  return (elem.head || !elem.classList) ? undefined : elem;
}

export function triggerEvent(element, eventName, data) {
  let event;
  if (window.CustomEvent && (window.CustomEvent === 'function')) {
    event = new window.CustomEvent(eventName, { detail: data });
  } else {
    event = document.createEvent('CustomEvent');
    event.initCustomEvent(eventName, true, true, data);
  }

  element.dispatchEvent(event);
}

export function showMessage(_options) {
  const options = {
    message: '',
    type: 'error',
    ..._options,
  };

  const messageNode = document.createElement('div');

  messageNode.className = `${options.type}-message`;
  messageNode.innerHTML = options.message;
  document.body.appendChild(messageNode);
}

export function objectIsEmpty(object) {
  return Object.keys(object).length === 0 && object.constructor === Object;
}

export function getItemIndexById(itemId, items) {
  let index = null;
  if (itemId && items && checkIfArray(items)) {
    for (let i = 0; i < items.length; i += 1) {
      if (items[i].id === itemId) {
        index = i;
        break;
      }
    }
  }
  return index;
}

export function getParamsStringFromUrl(name) {
  const nameMatch = window.location.href.match(new RegExp(`${name}=([^&]*)`, 'g', 'i'));
  return (nameMatch) ? `&${nameMatch[0]}` : '';
}
